import React from 'react'

import { Box, Grid, Tooltip, Zoom } from '@mui/material'
import { type EditAssetHolderProps } from './EditAssetHolderForm'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { AssetOrderStatusChip } from '../../components/chips/AssetOrderStatusChip'
import Chip from '@mui/material/Chip'
import CurrencyCodeChip from '../../components/chips/CurrencyCodeChip'
import { OrderTypeChip } from '../../components/chips/OrderTypeChip'

const EditAssetHolderOrdersView: React.FC<EditAssetHolderProps> = ({
  assetHolder
}: EditAssetHolderProps) => {
  const renderPaymentType = (paymentType: string | null): JSX.Element => {
    return (
      paymentType === undefined || paymentType === null
        ? (
          <></>
          )
        : (
          <Tooltip title={paymentType} TransitionComponent={Zoom} arrow placement="bottom">
            <Chip label={paymentType} variant="outlined"/>
          </Tooltip>
          )
    )
  }
  const columns: GridColDef[] = [
    { field: 'assetOrderId', headerName: 'Id', flex: 12, editable: false },
    { field: 'projectId', headerName: 'Project #', flex: 12, editable: false },
    {
      field: 'projectName',
      headerName: 'Project Name',
      flex: 40,
      renderCell: params => (
        <Tooltip title={params.value} TransitionComponent={Zoom} arrow placement="bottom">
          <span>{params.value ?? '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'orderStatus',
      headerName: 'Order Status',
      flex: 21,
      renderCell: params => (
        <AssetOrderStatusChip orderStatus={params.row.orderStatus}/>
      )
    },
    {
      field: 'orderType',
      headerName: 'Order Type',
      flex: 20,
      renderCell: params => (
        <OrderTypeChip orderType={params.value}/>
      )
    },
    { field: 'cellCost', headerName: 'Cell Cost', flex: 13, editable: false, align: 'right' },
    { field: 'numberOfCells', headerName: '# Cells', flex: 13, editable: false, align: 'right' },
    { field: 'valueOfCells', headerName: 'Value', flex: 13, editable: false, align: 'right' },
    { field: 'numberOfCellsOrdered', headerName: '# Ordered', flex: 13, editable: false, align: 'right' },
    { field: 'processedAt', headerName: 'Processed At', flex: 30, editable: false, align: 'center' },
    {
      field: 'paymentType',
      headerName: 'Payment Type',
      flex: 23,
      renderCell: params => (
        renderPaymentType(params.value)
      )
    },
    {
      field: 'orderCurrency',
      headerName: 'Currency',
      flex: 13,
      align: 'center',
      renderCell: params => (
        <CurrencyCodeChip name={''} code={params.value}/>
      )
    },
    {
      field: 'reference',
      headerName: 'Reference',
      flex: 40
    },
    {
      field: 'narrative',
      headerName: 'Narrative',
      flex: 20,
      renderCell: params => (
        <Tooltip title={params.value} TransitionComponent={Zoom} arrow placement="bottom">
          <span>{params.value ?? '-'}</span>
        </Tooltip>
      )
    }
  ]

  return (
    <>
      <Box sx={{ pb: 4 }}>
        <h3>Order History</h3>
        <Grid container spacing={4}>
          <Grid item md={12}>
            <DataGrid rows={assetHolder.assetHolderOrders} getRowId={(row) => row.assetOrderId} columns={columns}
                      autoHeight={true} pageSize={8} rowsPerPageOptions={[8]}/>
          </Grid>
        </Grid>
      </Box>

      {/* ==================================================================================================== */}

    </>
  )
}

export default EditAssetHolderOrdersView
